export default {"src":"/_next/static/media/carousel-icon-03.4a4e9bb2.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};